var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 12.7",
    style: {
      enableBackground: "new 0 0 20 12.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000120541270118598626300000011288367811121572252_);}\n\t.st1{fill:#012169;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#C8102E;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "FLAG_00000143603203971011560840000009349914144150195598_",
    transform: "translate(-62.811 -101.936)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M62.8,102.5c6.7,1.9,13.3-1.9,20,0v11.7c-6.7-1.9-13.3,1.9-20,0L62.8,102.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018202398880024312280000006294899146684728709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018202398880024312280000006294899146684728709_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,100.8h20v15h-20V100.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.2,100.8l7.6,5.7l7.6-5.7h2.4v1.9l-7.5,5.6l7.5,5.6v1.9h-2.5l-7.5-5.6l-7.5,5.6h-2.5v-1.9l7.5-5.6 l-7.5-5.6v-2H65.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.1,109.6l6.8,5v1.2l-8.5-6.2H76.1z M70.3,110.2l0.2,1.1l-6,4.5h-1.7L70.3,110.2z M82.8,100.8L82.8,100.8 l-7.8,6l0.1-1.4l6.2-4.6H82.8z M62.8,100.8l7.5,5.5h-1.9l-5.6-4.2V100.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.3,100.8v15h5v-15H70.3z M62.8,105.8v5h20v-5H62.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.8,106.8v3h20v-3H62.8z M71.3,100.8v15h3v-15H71.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGb);
export default __webpack_public_path__ + "static/media/FLAG_GB.1514dd028282f60b04f2472259528f58.svg";
export { ForwardRef as ReactComponent };